/*eslint-disable*/
import React, { Component } from 'react'
import { Table, Header, Container, Icon, Segment, Button, Label } from 'semantic-ui-react'
import Axios from 'axios'
import APP_CONSTANTS from '../../../config/constants'
import JobcardModal from './jobcardModal'
import moment from 'moment'
import LoadingPlaceholder from '../../placeholderComponent/loadingPlaceholder';

export default class VehicleJobcardHistory extends Component {

    state = {
        jobcardHistory: [],
        jobcardDataId: null,
        openModal: false,
        isVisible: false,
    };

    componentDidMount() {
        this.getVehicleHistory()
    };

    getVehicleHistory = () => {
        let vehicleId = this.props.getVehicleInfo[0].vehicle_obj ? this.props.getVehicleInfo[0].vehicle_obj.vehicleId : this.props.getVehicleInfo[0].vehicleId
        // console.log('>>', vehicleId)
        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')
        let data = JSON.stringify
            ({
                api_token: token,
                customerNo: customerNo,
                vehicleId: vehicleId,
                userId: userId
            })
        Axios.post(`${APP_CONSTANTS.BASE_URL}fleet/jobcard/getJobCards`, data, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            let currentVehicleId = this.props.currentVehId;
            let jobCardHistoryObject = response.data.data;

            let filteredJobCardHistory = jobCardHistoryObject.filter(o => o.jobCardId != currentVehicleId)
            this.setState({
                jobcardHistory: filteredJobCardHistory,
                isloading: true
            })

            let historyJB = [];
            jobCardHistoryObject.forEach(element => {
                if (element.jb_approval_status.approvalStatus != 1) {
                    historyJB.push(element)
                }
            });

            this.props.getLatestHistory && this.props.getLatestHistory(historyJB.length > 0 ? historyJB : '')
            // console.log("Test Filtered ", filteredJobCardHistory)
        }))
    };

    handleModel = (e, data) => {
        this.setState({
            jobcardDataId: data.dataId,
            openModal: true
        })
    };

    handleHide = () => {
        this.setState({
            isVisible: !this.state.isVisible
        })
    };

    render() {
        let info = this.state.jobcardHistory
        // console.log('Vehicle///', info)

        if (info) {
            return (
                <React.Fragment>
                    <div className="m-2">
                        <Table unstackable size="small" >
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell colSpan="7"><Header as="label" size="small" className="p-bold-500" color="blue">Vehicle Jobcard History</Header></Table.HeaderCell>
                                    <Table.HeaderCell textAlign="right"><Button circular size="mini" basic onClick={this.handleHide} color="blue"> <Icon name={this.state.isVisible ? "angle double up" : "angle double down"} />{this.state.isVisible ? "Show Less" : "Show More"}</Button></Table.HeaderCell>
                                </Table.Row>
                                <Table.Row >
                                    <Table.HeaderCell className="labelName p-bold-600">Jobcard No.</Table.HeaderCell>
                                    <Table.HeaderCell className="labelName p-bold-600">Jobcard Type</Table.HeaderCell>
                                    <Table.HeaderCell className="labelName p-bold-600">Vehicle In Date</Table.HeaderCell>
                                    <Table.HeaderCell className="labelName p-bold-600">Vehicle Out Date</Table.HeaderCell>
                                    <Table.HeaderCell className="labelName p-bold-600">Approver</Table.HeaderCell>
                                    <Table.HeaderCell className="labelName p-bold-600">Total Amount</Table.HeaderCell>
                                    <Table.HeaderCell className="labelName p-bold-600">Meter Reading</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="right" className="labelName p-bold-600">View</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body hidden={this.state.isVisible ? false : true}>
                                {info.length > 0 ?
                                    info.map((o) => (
                                        <Table.Row>
                                            <Table.Cell>{o.jobCardno}</Table.Cell>
                                            <Table.Cell>{o.jb_type ? o.jb_type.jobCardType : ''}</Table.Cell>
                                            <Table.Cell>{moment(o.vehicleInDate, "YYYY-MM-DD").format("DD-MM-YYYY")}</Table.Cell>
                                            <Table.Cell>{o.vehicleOutDate ? moment(o.vehicleOutDate, "YYYY-MM-DD").format("DD-MM-YYYY") : '-'}</Table.Cell>
                                            <Table.Cell>{o.jb_approval_status !== null ? o.jb_approval_status.approvalStatusName : 'Jobcard Created'}</Table.Cell>
                                            <Table.Cell>{o.totalAmt}</Table.Cell>
                                            <Table.Cell>{o.meterReading}</Table.Cell>
                                            <Table.Cell textAlign="right"><Button onClick={this.handleModel} dataId={o.jobCardId} size="mini" color="blue" icon basic><Icon name="eye" /></Button></Table.Cell>
                                        </Table.Row>
                                    )) :
                                    <Table.Row>
                                        <Table.Cell colSpan="8">
                                            <center>No Record Found</center>
                                        </Table.Cell>
                                    </Table.Row>
                                }
                            </Table.Body>
                        </Table>
                    </div>
                    {this.state.jobcardDataId !== null ? <JobcardModal spId={this.state.jobcardDataId} modalOpen={this.state.openModal} handleClose={() => this.setState({ openModal: false })} /> : ''}

                </React.Fragment>
            )

        }
    }
}
